<template>
  <div>
    <v-icon small class="ml-1" @click="copyToClipBoard(text)">
      content_copy
    </v-icon>
    <small v-if="copied" class="ml-1" style="color: green">copied</small>
  </div>
</template>
<script>
  export default {
    props: ["text"],
    data() {
      return {
        copied: false,
      };
    },
    methods: {
      copyToClipBoard(textToCopy) {
        navigator.clipboard.writeText(textToCopy);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 1000);
      },
    },
  };
</script>
